module.exports = __webpack_public_path__ + "img/Crime & Revenge City.6e23074f.png";